import { render, staticRenderFns } from "./GanttDetails.vue?vue&type=template&id=0837ef74&scoped=true&"
import script from "./GanttDetails.vue?vue&type=script&lang=js&"
export * from "./GanttDetails.vue?vue&type=script&lang=js&"
import style0 from "./GanttDetails.vue?vue&type=style&index=0&id=0837ef74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0837ef74",
  null
  
)

export default component.exports